/* The Studio / Managed flip on the homepage. v2.

   WHAT CHANGED FROM v1. Three things, all of them asked for; the card, the
   faces and the copy are untouched.

   1. THE SWITCH IS BUILT INSIDE THE STAGE, NOT ABOVE IT. v1 inserted it into
      the section wrapper before the card, so it floated in the gap above the
      box. It is now appended to .sf-stage and positioned at the top of it by
      rockkt-studio-flip-v2.css, which puts it inside the box.

      It is a SIBLING of .sf-card3d rather than a child, deliberately. A child
      would rotate with the card and end up mirrored and face-down on the
      Managed side. As a sibling it stays put while the card turns behind it,
      which is what a control on a card should do.

   2. THE HINT IS GONE. v1 built a "Tap either side to flip the card" line under
      the switch. It is not built at all now. The stylesheet also hides .sf-hint
      outright, so a cached copy of v1 cannot put it back.

   3. "See Managed plans" POINTS AT THE MANAGED SIDE OF THE PRICING PAGE.
      It was /pages/pricing, which lands on Studio - so a visitor who clicked a
      button about Managed arrived looking at the wrong plans and had to find
      the switch themselves. It is now /pages/pricing#managed, and
      rockkt-pricing-deeplink-v1.js on that page reads the hash and throws its
      switch. The hash matches the data-face value the pricing page's own
      switch already uses, so the two cannot drift apart without it being
      obvious.

   Everything below is v1 unchanged.

   ------------------------------------------------------------------------

   The "Rockkt Studio is free, by invitation" section (#studio) becomes a card
   with two faces: Studio on the front, exactly as it was, and Rockkt Managed on
   the back, built here in the SAME format so the two read as one card seen
   from both sides. A Studio | Managed switch sits on the card and a small flip
   link sits in each face's button row. Same mechanic as the pricing page:
   a 3D card, .flipped rotates it, the back is absolute and pre-rotated, the
   stage carries an explicit height because two absolute faces have none.

   Why at run time: templates/index.liquid is 236KB, past what the Admin API
   will replace as text. The front face is the existing markup MOVED into the
   card, not copied, so the fades, the confetti and the meter fill that
   rockkt-home.js and the v114 block wire to it carry on working untouched.
   The back is built once from the strings below. Nothing on it carries an id,
   so #hxDevice stays unique.

   COPY ON THE BACK, AND WHERE EACH LINE COMES FROM.
   Every line describes something that is built and live, checked against the
   fulfilment and go-live docs rather than written from the old page:
   - Gift Lab: Featured favourites or a multi-item box from tens of thousands
     of products (the catalogue-size fact rockkt-factfix-v2.js enforces).
   - We print the letter and envelope and pack a kraft box with the logo:
     the Fulfilment page's print and assemble step, and the branded outer box.
   - Dispatched within one business day, tracked, Royal Mail in the UK and
     Parcel2Go abroad with DDP customs: the Fulfilment page's shipping step and
     the Gift Lab section's own "Dispatched in 1 business day" line.
   - Recipient confirms, updates or declines the address first: the
     /confirm/[code] page and the address-confirmation holds. Twelve business
     hours is the window the Gift Lab page's own card prints.
   - The ROI guarantee is MANAGED ONLY and the figures are the ones on the
     pricing section directly below: 7x pipeline or 3x revenue, or fees
     credited back. Nothing else numeric appears here.
   - "From £99 a month" and "no minimum term" are the two real floors, same as
     the old index carried. Gift credit rolls over and is only spent on
     delivery: the pricing section's own words.
   - Nothing priced goes in the parcel: the pick sheet is INTERNAL ONLY, by
     decision. Worth saying to a buyer, so it is said.
   Rockkt Admin is internal and is never named. */
(function () {
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function backFaceHTML() {
    var ck = '<svg class="icn"><use href="#g-check"/></svg>';
    return '' +
    '<div>' +
      '<span class="hx-new sf-new-m in"><svg class="icn"><use href="#g-truck"/></svg>Rockkt Managed</span>' +
      '<h2>Rockkt Managed does the sending for you.</h2>' +
      '<p class="lead">It is the full-service way in: you pick the person and the gift, and Rockkt sources it, prints the letter, packs the box and posts it. Open now, no invitation needed.</p>' +
      '<ul class="flist">' +
        '<li>' + ck + '<span><b>Gift Lab</b>: a ready-to-dispatch favourite, or a multi-item box built from tens of thousands of products</span></li>' +
        '<li>' + ck + '<span>We print the robot-written letter and branded envelope, then pack everything in a kraft box printed with your logo</span></li>' +
        '<li>' + ck + '<span>Dispatched within one business day, tracked. Royal Mail in the UK; abroad we handle the shipping and the customs</span></li>' +
        '<li>' + ck + '<span>The recipient confirms, updates or declines the address before anything ships, so nothing lands on an empty desk</span></li>' +
        '<li>' + ck + '<span>No price, no invoice, nothing in the parcel but the gift, the letter and your branding</span></li>' +
        '<li>' + ck + '<span><b>Backed by the ROI guarantee</b>: 7&times; pipeline or 3&times; revenue, or we credit your fees back</span></li>' +
      '</ul>' +
      '<div class="hx-sbtns">' +
        '<a class="btn btn-primary hx-fun" href="/pages/free-sample" data-pop="big"><svg class="icn"><use href="#g-gift"/></svg>Get a free sample</a>' +
        '<a class="btn hx-btn2 hx-fun" href="/pages/pricing#managed"><svg class="icn"><use href="#g-grid"/></svg>See Managed plans</a>' +
        '<button class="sf-flipto" type="button" data-goface="studio"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 0 1 15.5-6.2M21 12a9 9 0 0 1-15.5 6.2"/><path d="M18 3v3.5h-3.5M6 21v-3.5h3.5"/></svg>Flip back to Studio</button>' +
      '</div>' +
      '<p class="hx-fine">Built for teams where sourcing, packing and posting has started eating the week. Plans from &pound;99 a month with no minimum term. Gift credit is loaded separately, rolls over, and is only spent when a gift is delivered. Everything in Studio is included.</p>' +
    '</div>' +
    '<div class="hx-device in">' +
      '<div class="hd-bar"><svg class="icn"><use href="#g-truck"/></svg>Rockkt Managed &middot; Full service &middot; Open now</div>' +
      '<div class="hd-body">' +
        '<div class="hx-row"><span class="rl">Gift credit</span><div><b>Held as a company balance</b> &middot; rolls over, never expires</div><div class="hx-meter"><i></i></div></div>' +
        '<div class="hx-row"><span class="rl">We send</span><div>Your chosen gift, packed in a branded box with a robot-written letter, envelope and Landing Pad, posted tracked</div></div>' +
        '<div class="hx-row"><span class="rl">You get, on top of Studio</span>' +
          '<div class="hx-tags"><span>Gift Lab</span><span>Sourcing &amp; packing</span><span>Printed letter &amp; envelope</span><span>Branded outer box</span><span>Tracked delivery</span><span>Address confirmation</span><span>International &amp; customs</span><span>Compliance caps</span><span>ROI guarantee</span></div>' +
        '</div>' +
      '</div>' +
      '<a class="hx-send hx-fun" href="/pages/free-sample" data-pop><svg class="icn"><use href="#g-gift"/></svg>Get a free sample</a>' +
    '</div>';
  }

  function build() {
    var sec = document.getElementById('studio');
    if (!sec || sec.querySelector('.sf-stage')) return;
    var front = sec.querySelector('.hx-studio');
    var wrap = front && front.parentNode;
    if (!front || !wrap) return;

    /* The switch. Built the same as v1; where it goes is what changed. */
    var sw = document.createElement('div');
    sw.className = 'sf-switch';
    sw.setAttribute('role', 'tablist');
    sw.setAttribute('aria-label', 'Choose Studio or Managed');
    sw.innerHTML =
      '<button type="button" class="active" data-face="studio" role="tab" aria-selected="true"><span class="sf-name">Rockkt Studio</span><span class="sf-tag">Software only &middot; Free</span></button>' +
      '<button type="button" data-face="managed" role="tab" aria-selected="false"><span class="sf-name">Rockkt Managed</span><span class="sf-tag">Full service &middot; From &pound;99</span></button>';

    /* The stage. The front face is the EXISTING card, moved, not copied. */
    var stage = document.createElement('div');   stage.className = 'sf-stage';
    var card  = document.createElement('div');   card.className  = 'sf-card3d';
    var fF    = document.createElement('div');   fF.className    = 'sf-face sf-front';
    var fB    = document.createElement('div');   fB.className    = 'sf-face sf-back off';
    fB.setAttribute('aria-hidden', 'true');

    var back = document.createElement('div');
    back.className = front.className.replace(/\bhx-reveal\b|\bd\d\b/g, '').trim() + ' sf-managed';
    back.innerHTML = backFaceHTML();

    wrap.insertBefore(stage, front);
    /* Sibling of the card, not a child: it must not turn with it. */
    stage.appendChild(sw);
    stage.appendChild(card);
    card.appendChild(fF);
    card.appendChild(fB);
    fF.appendChild(front);
    fB.appendChild(back);

    /* A flip link in the front face's button row, matching the one on the back */
    var fbtns = front.querySelector('.hx-sbtns');
    if (fbtns) {
      var b = document.createElement('button');
      b.className = 'sf-flipto'; b.type = 'button'; b.setAttribute('data-goface', 'managed');
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 0 1 15.5-6.2M21 12a9 9 0 0 1-15.5 6.2"/><path d="M18 3v3.5h-3.5M6 21v-3.5h3.5"/></svg>See Rockkt Managed';
      fbtns.appendChild(b);
    }

    var current = 'studio', hideTimer = null;
    function face(n) { return n === 'studio' ? fF : fB; }
    function sizeStage() {
      var h = face(current).offsetHeight;
      if (h) stage.style.height = h + 'px';
    }
    function setFace(n) {
      if (n === current) return;
      current = n;
      var toStudio = (n === 'studio');
      fF.style.visibility = 'visible'; fB.style.visibility = 'visible';
      fF.classList.toggle('off', !toStudio);
      fB.classList.toggle('off', toStudio);
      fF.setAttribute('aria-hidden', toStudio ? 'false' : 'true');
      fB.setAttribute('aria-hidden', toStudio ? 'true' : 'false');
      card.classList.toggle('flipped', !toStudio);
      sw.querySelectorAll('button').forEach(function (b) {
        var on = b.getAttribute('data-face') === n;
        b.classList.toggle('active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      /* anything on the newly shown face that fades in must be visible now */
      face(n).querySelectorAll('.hx-reveal, .reveal, .hx-device').forEach(function (el) { el.classList.add('in'); });
      sizeStage();
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(function () { (toStudio ? fB : fF).style.visibility = 'hidden'; }, RM ? 0 : 900);
    }

    sw.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      setFace(b.getAttribute('data-face'));
    });
    sec.querySelectorAll('[data-goface]').forEach(function (b) {
      b.addEventListener('click', function () { setFace(b.getAttribute('data-goface')); });
    });

    fB.style.visibility = 'hidden';
    sizeStage();
    setTimeout(sizeStage, 250);
    setTimeout(sizeStage, 1200);
    window.addEventListener('load', sizeStage);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sizeStage);
    var rt = null;
    window.addEventListener('resize', function () { if (rt) clearTimeout(rt); rt = setTimeout(sizeStage, 120); });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { sizeStage(); });
      ro.observe(front); ro.observe(back);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();
